<template>
  <div name="hres8ax-popup-detail-deduction" id="hres8ax-popup-detail-deduction" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRES8AXC2']['50'] }}</h4>
        </div>
        <div class="modal-body detail detail-responsive">
          <div class="panel-body">
            <div class="detail detail-responsive">
             
             <div class="col-md-12">
                <div class="detail-header"><u>{{ labels['HRES8AXC2']['50'] }}</u></div>
              </div>
             <div class="clearfix detail-row">
                <!-- <div class="detail-left label-left">{{ labels['HRES8AXC2']['50'] }}</div> -->
                  <div class="detail-right">
                      <div class="detail-text width-70" id="amtdeduct" name="amtdeduct">{{ detailDeductionSelected.amtdeduct }}</div>
                  </div>
              </div>
               <div class="col-md-12">
                <div class="detail-header"><u>{{ labels['HRES8AXC2']['60'] }}</u></div>
              </div>
              <div class="clearfix detail-row">
                <!-- <div class="detail-left label-left">{{ labels['HRES8AXC2']['60'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="amtdeduct" name="amtdeduct">{{ detailDeductionSelected.amtdeduct }}</div>
                  </div> -->
              </div>
              <div class="col-md-12">
                <div class="detail-header"><u>{{ labels['HRES8AXC2']['70'] }}</u></div>
              </div>
               <div class="clearfix detail-row">
                <!-- <div class="detail-left label-left">{{ labels['HRES8AXC2']['70'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="amtdeduct" name="amtdeduct">{{ detailDeductionSelected.amtdeduct }}</div>
                  </div> -->
              </div>


            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres8ax-popup-detail-deduction',
  props: [ 'labels', 'data', 'columns', 'detailDeductionSelected' ]
}
</script>

<style lang="scss">
	#settime {
	  animation-duration: 1s;
	}
	.hres8ax-popup-edit-box {
		border-top: 1px solid #EDEDED;
		padding: 5px;
		margin: 5px 0 0 0;
	}
	
</style>


// WEBPACK FOOTER //
// popupDetailDeduction.vue?7980d68c